import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fractionInputValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const isFraction = /^[0-9]+\/[1-9][0-9]*$/.test(value);
        const isDecimal = /^[0-9]+\.?[0-9]*$/.test(value);
        const isPercentage = /^[0-9]+\.?[0-9]*%$/.test(value);

        const fractionValid = isFraction || isDecimal || isPercentage;

        return !fractionValid
            ? {
                  fractionInvalid: {
                      isFraction,
                      isDecimal,
                      isPercentage,
                  },
              }
            : null;
    };
}
